// Demo/preview dataset for the Financial Analysis dashboard.
//
// Shows what the page looks like once QuickBooks is fully connected and
// COGS accounts are confirmed — every figure tagged 'quickbooks' as if live.
// Used only when Demo Mode is explicitly switched on (see FinancialDashboard.js);
// never falls back to this silently, and never used when Demo Mode is off.

const MONTHS = [
    'Oct 2025', 'Nov 2025', 'Dec 2025', 'Jan 2026', 'Feb 2026', 'Mar 2026',
    'Apr 2026', 'May 2026', 'Jun 2026', 'Jul 2026', 'Aug 2026', 'Sep 2026',
];

const MONTHLY_REVENUE = [172000, 181000, 210000, 198000, 205000, 224000, 231000, 246000, 258000, 267000, 279000, 291000];
const MONTHLY_COGS = [86000, 89000, 101000, 95000, 97000, 105000, 107000, 113000, 117000, 120000, 124000, 128000];

const PRODUCTS = [
    { productName: 'Panama Black', revenue: 612000, cost: 291000 },
    { productName: 'Stout Truffle', revenue: 498000, cost: 249000 },
    { productName: 'Ethiopian Yirgacheffe', revenue: 445000, cost: 209000 },
    { productName: 'Vanilla Oat Cold Brew', revenue: 387000, cost: 197000 },
    { productName: 'Colombian Dark Roast', revenue: 356000, cost: 178000 },
    { productName: 'Nitro Cascara', revenue: 249000, cost: 133000 },
];

function withMargins(products) {
    return products.map((p, i) => {
        const profit = p.revenue - p.cost;
        const profitMargin = (profit / p.revenue) * 100;
        const unitsSold = Math.round(p.revenue / (4.5 + i * 1.2)); // varied per-unit price, spread wide enough to read distinctly per product
        return {
            id: i + 1,
            productName: p.productName,
            revenue: p.revenue,
            cost: p.cost,
            profitMargin,
            unitsSold,
            profitPerUnit: profit / unitsSold,
        };
    });
}

const productProfitability = withMargins(PRODUCTS);

const totalRevenue = MONTHLY_REVENUE.reduce((a, b) => a + b, 0);
const totalCogs = MONTHLY_COGS.reduce((a, b) => a + b, 0);
const grossProfit = totalRevenue - totalCogs;
const grossMarginPct = (grossProfit / totalRevenue) * 100;

export const demoFinancialData = {
    kpiData: {
        totalRevenue: { value: totalRevenue, change: 34.2, trend: 'up', source: 'quickbooks' },
        netProfitMargin: { value: grossMarginPct - 2.5, change: 4.1, trend: 'up', source: 'quickbooks' }, // net after modest opex
        costOfGoodsSold: { value: totalCogs, change: 12.8, trend: 'stable', source: 'quickbooks' },
        grossMargin: { value: grossMarginPct, change: 2.4, trend: 'up', source: 'quickbooks' },
        inventoryTurnover: { value: 8.4, change: 0.6, trend: 'up', source: 'quickbooks' },
        daysSalesOutstanding: { value: 22, change: -3, trend: 'up', source: 'quickbooks' },
        outstandingReceivables: { value: 84000, change: -5.2, trend: 'up', source: 'quickbooks' },
        outstandingPayables: { value: 31000, change: 2.1, trend: 'stable', source: 'quickbooks' },
    },
    productProfitability,
    chartData: {
        revenueData: {
            labels: MONTHS,
            values: MONTHLY_REVENUE,
            connected: true,
        },
        costBreakdown: {
            ingredients: 44,
            labor: 21,
            overhead: 17,
            packaging: 18,
        },
        profitMarginByProduct: productProfitability
            .slice(0, 5)
            .map(p => ({ product: p.productName, margin: p.profitMargin })),
        monthlyProfitLoss: {
            labels: MONTHS,
            revenue: MONTHLY_REVENUE,
            costs: MONTHLY_COGS,
            profit: MONTHLY_REVENUE.map((rev, i) => rev - MONTHLY_COGS[i]),
            connected: true,
            costsAvailable: true,
        },
    },
};

export default demoFinancialData;
